var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tabs',{attrs:{"tabs":_vm.tabs,"active-tab":_vm.activeTab},on:{"switchToTab":function($event){return _vm.switchToTab($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }